module.exports = __webpack_public_path__ + "static/media/galerija_2019 (9).0c4df903.jpg";